import type { ReactNode } from "react";

type ManagementToolbarProps = {
  search: ReactNode;
  children: ReactNode;
};

const ManagementToolbar = ({ search, children }: ManagementToolbarProps) => (
  <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
    {search}
    <div className="card-head-group d-flex align-items-center gap-2">{children}</div>
  </div>
);

export default ManagementToolbar;
